export default __webpack_public_path__ + "static/media/container-status-icon.52e2b7ab.svg";